const methods = ({ request }) => ({
  getSeasonForPosition: async (seasonType, season, position, formulaId) =>
    request(`Stats/Season/Position/${seasonType}/${season}/${position}/${formulaId}`),

  getWeeklyForPosition: async ({ year, position, week, formulaId }) =>
    request(`Stats/Weekly/Position/${year}/${week}/${position}/${formulaId}`),

  getWeeklyBoxScores: async ({ year, formulaId, week, matchup }) =>
    request(`GameScans/Weekly/${year}/${formulaId}/${week}/${matchup}`),

  getSeasonBoxScores: async ({ year, formulaId, team }) =>
    request(`GameScans/Season/${year}/${formulaId}/${team}`),

  getStrengthOfSchedule: async ({ year, calcStart, calcEnd, showStart,
     showEnd, position, formulaId }) =>
      request(`Team/StrengthOfSchedule/${year}/${calcStart}/${calcEnd}/${showStart}/${showEnd}/${position}/${formulaId}`),

  getGameStatsMatchups: async ({ year, formulaId, startWeek, endWeek }) =>
    request(`Team/GameStatsMatchups/${year}/${startWeek}/${endWeek}/${formulaId}`),
});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/stats.js